import React from 'react';
import { useTranslation } from "react-i18next";

import { formatPrice, getFinanceWeekly, getLeaseBiWeeklyFromMsrp } from '../../../utils';

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';

import Button from '../../1_Atoms/Button/Button';
import Collapse from '../../2_Molecules/Collapse/Collapse';

export const TrimList = ({ trims, setSelectedTrim, selectedTrim, setLegalModalOpen, showFinancePrice, ...props }) => {
    const summaryCalculator = window.summaryCalculator;
    const [trimsData, setTrimsData] = React.useState([]);
    let [financeTerm, setFinanceTerm] = React.useState(parseInt(sessionStorage.getItem(Constants.FinanceTerm)));
    let [leaseTerm, setLeaseTerm] = React.useState(parseInt(sessionStorage.getItem(Constants.LeaseTerm)));
    const [expandedIndex, setExpandedIndex] = React.useState(null);
    const listRef = React.useRef();
    const { t, i18n } = useTranslation(['trims']);
    const handleTrimClick = e => {
        const $el = e.target;
        if ($el.matches('button.mz-trims-list__select-trim-button')) {
            e.stopPropagation();
            const index = Number($el.getAttribute('data-index'));
            setSelectedTrim(index);
        }
    };

    const setTermIndex = ()=>{
        // Fetch the selected term or select the last one
        let foundLeaseTermIndex = summaryCalculator.FinancialInfo.lease.findIndex(x => x.term === leaseTerm);
        if(!leaseTerm || foundLeaseTermIndex === -1)
            foundLeaseTermIndex = summaryCalculator.FinancialInfo.lease.length - 1;
        setLeaseTerm = summaryCalculator.FinancialInfo.lease[foundLeaseTermIndex].term;

        let foundFinanceIndex = summaryCalculator.FinancialInfo.apr.findIndex(x => x.term === financeTerm);
        if(!financeTerm || foundFinanceIndex === -1)
            foundFinanceIndex = summaryCalculator.FinancialInfo.apr.length - 1;
        setFinanceTerm = summaryCalculator.FinancialInfo.apr[foundFinanceIndex].term;
    }

    React.useEffect(() =>{
        document.addEventListener('click', handleTrimClick);

        if(summaryCalculator.FinancialInfo){
            setTermIndex()
        }

        setTrimsData(trims);

        if (listRef.current) {
            window.removeEventListener('resize', setListMaxHeight);
            window.addEventListener('resize', setListMaxHeight);
            setListMaxHeight();
        }

        return () => {
            document.removeEventListener('click', handleTrimClick);
          };
    },[trims,  summaryCalculator.FinancialInfo, summaryCalculator.FinancialInfo?.calculatedCash, summaryCalculator.FinancialInfo?.calculatedFinance, summaryCalculator.FinancialInfo?.calculatedLease]);

    function isJellyPathConform(jelly)
    {
        if(!jelly)
            return false;

        var jellyContents = jelly.split('-');

        // Validate that we have a trim
        if(jellyContents && !jellyContents[jellyContents.length - 2])
            return false;
        else
            return true;
    }

    function getImage(trim) {
        const imagePath = trim.visual.static_content_base_path;
        //const key = Object.keys(trim.visual.exteriors)[0];

        if (isJellyPathConform(trim.visual.jelly)) {
            // Patch for the value received from the backend that has a space in.
            return `${imagePath}${trim.visual.jelly_path}${trim.visual.jelly.replace(/ /g, "-")}`;
        } else {
            // Patch for when the jelly hasn't been set in the api correctly (i.e. missing a trim like this `2022-MAZDA3--TAB.png`;)
            return `${imagePath}${trim.visual.jelly_path}${trim.title.replace(/ /g, '-')}-TAB.png`;
        }
    }

    function getLegalContent(legalArr){
        let legalContent = '';
        legalArr.map((legal, index) => {
            const icon = legal.icon_type === 'disclaimer' ? 'disclaimer' : 'feature_' + legal.icon_type;
            legalContent += `
            <div class="mz-trims-list__legal"><i class="mz-svg mz-svg--grey mz-svg-${icon}" style="font-size: 2rem;"></i>
            <p>${legal.content}</p></div>`;
        })
        return legalContent;
    }

    function getTrimDataContent(item, index) {
        let highlitedfeatureList = '<ul class="mz-trims-list__highlited-feature-list">';
        item.highlighted_features.forEach(feature => {
            let featureItem = '<li class="mz-trims-list__highlited-feature-item">';
            featureItem += `<i class="mz-svg mz-svg--grey mz-svg-feature_${feature.icon_type} mz-i-undefined" style="font-size: 1.85rem;"></i>`;
            featureItem += `<p>${feature.content}</p></li>`;
            highlitedfeatureList += featureItem;
        });
        highlitedfeatureList += '</ul>';
        const featureListTitle = item.feature_list_title?`<h3 class="mz-trims-list__include-features-title">${item.feature_list_title}</h3>`:'';
        let featureList = '<ul class="mz-trims-list__feature-list">';

        item.feature_list.forEach(feature => {
            let featureItem = '<li class="mz-trims-list__featurei-item">';
            featureItem += `<p>${feature.content}</p></li>`;
            featureList += featureItem;
        });
        featureList += '</ul>';

        //const selectTrimButton = index === selectedTrim?`<button class="mz-btn mz-btn--secondary mz-trims-list__select-trim-button" data-index="${index}"  disabled="true"><span class="mz-trims-list__select-trim-button-selected"><i class="mz-svg mz-svg--white mz-svg-checkmark mz-i-undefined"></i></span>${t("general:button_selected")}</button>`: `<button class="mz-btn mz-btn--secondary mz-trims-list__select-trim-button"  data-index="${index}">${t("btn_select_this_trim")}</button>`;

        const content = highlitedfeatureList + featureListTitle + featureList;
        return content;
    }

    function getTrimButton(item, index) {
        const selectTrimButton = index === selectedTrim?`<button class="mz-btn mz-btn--primary mz-trims-list__select-trim-button mz-trims-list__select-trim-button-header" data-index="${index}" disabled="disabled"><span>${t("general:button_selected")}</span></button>`: `<button class="mz-btn mz-btn--primary mz-btn--red mz-trims-list__select-trim-button mz-trims-list__select-trim-button-header"  data-index="${index}"><span>${t("btn_select_this_trim")}</span></button>`;
        return selectTrimButton;
    }

    function setListMaxHeight(){
        if (listRef.current)
            if (window.innerWidth < 1025) {
                listRef.current.style.maxHeight = 'unset';
            } else {
                const incentivebar = document.querySelector('.mz-alert__item'); // Red alert bar
				const submenu=document.querySelector(".mz-sticky-submenu");
				const pricingBar=
                listRef.current.style.height = `${window.innerHeight - (submenu?.offsetTop + document.querySelector(".mz-sticky-submenu")?.offsetHeight + document.querySelector(".mz-pricing")?.offsetHeight + (incentivebar ? incentivebar.offsetHeight : 0) + 40)}px`;
				if(!submenu || !pricingBar){
					setTimeout(setListMaxHeight, 100);
				}
            }

    }

    if(!summaryCalculator.FinancialInfo.calculatedFinance)
        return (<></>)
    else
    return (
        <div className="mz-trims-list" ref ={listRef}>
            <h2 className="mz-trims-list__title">{t("select_a_trim")}</h2>
            {summaryCalculator.displayWarning() ? <div className="mz-alert-message paragraph paragraph--tight">
                <i className="mz-svg mz-svg-warning mz-svg--red"></i>&nbsp;
                <span className="mz-alert-message__text">{t("warning_change_trim")}</span>
            </div> : null}
            {trimsData.map((trim, index) => {
                const trimContent = getTrimDataContent(trim, index);
                const thumbnail = getImage(trim);
                const button = getTrimButton(trim, index);
                const legalContent = getLegalContent(trim.alert_features);
                return <Collapse key={index} Selected={selectedTrim === index} ColCarText1={trim.title} ColCarText1Button={button} showCheck={index === selectedTrim ? true : false} ColCarText2={`${formatPrice(trim.financial.msrp)}`} ColCarText3={
                    `${showFinancePrice?
                        `(${getFinanceWeekly(trim.financial.msrp, summaryCalculator.FinancialInfo?.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex].aprRate, summaryCalculator.FinancialInfo?.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex].term)}${t("general:week")})`:
                        !window.hideLeaseInCard ? `(${getLeaseBiWeeklyFromMsrp(trim.financial.msrp, summaryCalculator.FinancialInfo?.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].leaseRate, summaryCalculator.FinancialInfo?.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].term)}${t("general:bi_week")})` : ''
                    }`} LegalContent={legalContent} ColCarImg={thumbnail} ColBoxText={trimContent} isPopular={trim.is_popular} index={index} isExpanded={expandedIndex === index} setExpandedIndex={setExpandedIndex}>        
                </Collapse>
			})}
            <div className="mz-legal mz-mobile">
            <Button
                className="mz-btn mz-btn--legal text--grey"
                label={t("general:legal")}
                colour="grey"
                icon={true}
                iconAfter={true}
                svg_className=""
                svg_list="plus"
                size={0.6}
                onClick={() => {
					document.querySelector('body').classList.add('disabled');
					setLegalModalOpen(true)
				}}
            />
            </div>
        </div>
    )
}


export default TrimList;